const VARIANTS = {
  dark:     { src: '/CollaboXD-Header-Logo.svg', aspect: 992.51 / 241.09 }, // white wordmark + cyan mark, for dark headers
  light:    { src: '/collaboxd-logo-light.svg', aspect: 992.51 / 241.09 }, // white wordmark + cyan mark, for use on dark/coloured surfaces
  full:     { src: '/collaboxd-logo.svg', aspect: 992.51 / 241.09 },       // navy wordmark + cyan mark, for light surfaces
  markOnly: { src: '/collaboxd-mark.svg', aspect: 194.33 / 199.32 },
};

export default function CollaboXDLogo({ variant = 'full', height = 32 }) {
  const { src, aspect } = VARIANTS[variant] ?? VARIANTS.full;
  return (
    <img
      src={src}
      alt="Collabo XD"
      height={height}
      width={Math.round(height * aspect)}
      style={{ display: 'block', flexShrink: 0 }}
    />
  );
}
